export function isImageLandscape(imageUrl: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
        const img = new Image();

        img.onload = function () {
            if (img.width > img.height) {
                resolve(true);
            } else {
                resolve(false);
            }
        };

        img.onerror = function () {
            reject(new Error('Failed to load the image from the URL: ' + imageUrl));
        };

        img.src = imageUrl;
    });
}

export function extractContentFromDataURL(dataURL: string) {
    const dataParts = dataURL.split(',');
    if (dataParts.length === 2) {
        return dataParts[1];
    } else {
        throw new Error('Invalid Data URL');
    }
}

export function getBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onerror = () => {
            reject(new Error('Error while reading the file.'));
        };

        reader.onload = () => {
            if (typeof reader.result === 'string') {
                resolve(reader.result);
            } else {
                reject(new Error('Unexpected result type. Expected a string.'));
            }
        };

        if (file instanceof Blob) {
            reader.readAsDataURL(file);
        } else {
            reject(new Error('Invalid file type. Expected a Blob.'));
        }
    });
}
